import { Component } from '@angular/core';
import { PoBreadcrumb, PoContainerModule, PoPageModule } from '@po-ui/ng-components';

@Component({
  selector: 'app-new-sales',
  standalone: true,
  imports: [PoPageModule, PoContainerModule,],
  templateUrl: './new-sales.component.html',
  styleUrl: './new-sales.component.scss'
})
export class NewSalesComponent {
  readonly breadcrumbItems: PoBreadcrumb = {
    items: [
      { label: 'Início', link: '/' },
      { label: 'Novas vendas', link: '/novas-vendas' }
    ]
  }
}
